import { render, staticRenderFns } from "./storeProduct.vue?vue&type=template&id=0457c7e4&"
import script from "./storeProduct.vue?vue&type=script&lang=js&"
export * from "./storeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports